import * as React from 'react';
import { Form } from "react-redux-form";
import * as DTOS from "../FeralScan.dtos";
import * as DashboardActionCreators from "../actions/dashboard.actions";
import * as DataActionCreators from "../actions/data.actions";
import * as SurveyActionCreators from "../actions/survey.actions";
import { withTheme } from '../common/withTheme';
import * as Configuration from '../configuration';
import { SurveyState } from "../reducers/survey.reducer";
import FormItem from '../components/Data/Survey/FormItem';
import SelectControl from '../components/Data/Survey/controls/SelectControl';
import classNames = require('classnames');
import Loader from 'react-loaders';
import { actions as FormActions } from 'react-redux-form';
import { IAppState } from '../app';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router';
import { History } from 'history'
import { ReferenceDataState } from '../reducers/referenceData.reducer';

export type SurveyFormProps = {
    classification: string;
    eventTypeId: number;
    history?: History;
    loading: boolean;
    mapMarkerComponent: any;
    //map: MapState,
    referenceData: ReferenceDataState;
    speciesId: number;
    survey: DTOS.Survey;
    uploadingFile: boolean;
    theme?: string;
    type: string;
    selectedPlotId: number;
};

export type SurveyFormPropsMapped = {
    submitFailed?: boolean;
    userPlots?: DTOS.Plot[];
}

export type SurveyFormActions = {
    //onSubmitSurveyRoute: (props: SurveyFormPropsAndActions) => string;

    changeEventType: typeof SurveyActionCreators.changeEventTypeRequest;
    changeSpecies: typeof SurveyActionCreators.changeSpeciesRequest;
    changeTab(tab: string): void;
    clearSurvey: typeof SurveyActionCreators.clearSurveyRequest;
    error: typeof DashboardActionCreators.errorRequest;
    getEventQuestions: typeof SurveyActionCreators.getEventQuestionsRequest;
    setQuestionValue: typeof SurveyActionCreators.setQuestionValueRequest;
    submitSurvey: typeof SurveyActionCreators.saveEventRequest;
    uploadFiles: typeof SurveyActionCreators.uploadFilesRequest;
    resetForm: typeof FormActions.reset;
    getUserPlots?: typeof DataActionCreators.getUserPlotsRequest;
};

export type SurveyFormPropsAndActions = SurveyFormProps & SurveyFormPropsMapped & SurveyFormActions;

interface ISurveyFormContainerState {
    PostSubmitRoute: string
}

class SurveyForm extends React.Component<SurveyFormPropsAndActions, ISurveyFormContainerState> {

    constructor(props, context) {
        super(props, context);
        this.onSelectedSpeciesChanged = this.onSelectedSpeciesChanged.bind(this);
        this.onSelectedEventTypeChanged = this.onSelectedEventTypeChanged.bind(this);

        this.state = {
            PostSubmitRoute: undefined
        }
    }

    componentDidMount() {
        const { classification, type } = this.props;
        const { classifications, types } = this.props.referenceData;

        if (!this.props.loading && !this.props.userPlots) {
            this.props.getUserPlots(false);
        }

        if (classification && classification != "all" && classifications && classifications.findIndex(c => c.code.toLowerCase() == classification.toLowerCase()) > -1) {
            const speciesId = classifications.find(c => c.code.toLowerCase() == classification.toLowerCase()).id;
            this.props.changeSpecies(speciesId);
        }

        if (type && type != "all" && types && types.findIndex(c => c.label.toLowerCase() == type.toLowerCase()) > -1) {
            const eventTypeId = parseInt(types.find(t => t.label.toLowerCase() == type.toLowerCase()).value);
            this.props.changeEventType(eventTypeId);
        } else if (types && types.length == 1) {
            // if only one type available, choose it by default
            this.props.changeEventType(parseInt(types[0].value));
        }

        if (this.props.speciesId && this.props.eventTypeId) {
            this.props.getEventQuestions(this.props.speciesId, this.props.eventTypeId);
        }
    }

    componentDidUpdate(prevProps: SurveyFormPropsAndActions) {
        if (this.props.speciesId && this.props.eventTypeId
            && (prevProps.speciesId != this.props.speciesId || prevProps.eventTypeId != this.props.eventTypeId ||
                (prevProps.survey && !this.props.survey) // we had a survey but cleared it
            )
        ) {
            this.props.getEventQuestions(this.props.speciesId, this.props.eventTypeId);
        }
    }

    async onSelectedSpeciesChanged(selectedOption: string) {
        if (selectedOption == "-1") {
            this.props.clearSurvey();
        }
    }

    async onSelectedEventTypeChanged(selectedOption: string) {
        if (selectedOption == "-1") {
            this.props.clearSurvey();
        }
    }

    onSubmit(form: SurveyState) {
        this.props.submitSurvey(form.survey);
        const routeQuestion = form.survey.questions.find(q => q.metadataType == "Route");

        if (routeQuestion) {
            switch (routeQuestion.value) {
                //TODO: Some others
                case "/site-detail-event":
                case "/survey":
                    this.props.resetForm("surveyState.survey")
                    this.props.clearSurvey();
                    break;
                case "/map":
                case "/user":
                case "/content":
                default:
                    this.props.resetForm("surveyState.survey")
                    this.props.clearSurvey();
                    //this.props.changeTab(Configuration.ContentTab);
                    break;
            }
        } else {
            this.props.resetForm("surveyState.survey")
            this.props.clearSurvey();
            
            /*const { onSubmitSurveyRoute, history } = this.props;

            if (onSubmitSurveyRoute) {
                history.push(onSubmitSurveyRoute(this.props));

                return;
            }

            history.push(``);*/
        }

    }

    onDrop(id, id2) {

    }

    render() {
        const { classification, survey, type } = this.props;
        const { classifications, types } = this.props.referenceData;

        //const orderedSurveyQuestions = survey && survey.questions ? survey.questions.sort((q1, q2) => q1.rank - q2.rank) : undefined;

        /*let speciesControl = classification == "all" ?
            <div>
                <label className="text-muted lead my-0">Species</label>
                <SelectControl
                    model=".speciesId"
                    mandatory={true}
                    onChange={this.onSelectedSpeciesChanged}
                    options={classifications}
                    readOnly={false}
                />
            </div> : undefined;*/

        let eventTypeControl = (!type || type == "all") && types.length > 1 ?
            <div>
                <label className="text-muted lead my-0">Type</label>
                <SelectControl
                    model=".eventTypeId"
                    mandatory={true}
                    onChange={this.onSelectedEventTypeChanged}
                    options={types}
                    readOnly={false}
                />
            </div> : undefined;

        let dynamicFormItems = survey && survey.questions ? survey.questions.map((q, i) => {
            return (<FormItem
                formItemType={q.questionTypeCode}
                formTemplateItemId={q.questionId}
                key={q.surveyQuestionId}
                mandatory={q.mandatory}
                name={q.questionDescription}
                options={q.options ? q.options : undefined}
                model={`.survey.questions.${i}`}
                questionIndex={i}
                survey={this.props.survey}
                userPlots={this.props.userPlots}
                value={q.value}
                error={this.props.error}
                onDrop={this.onDrop.bind(null, 1)}
                setQuestionValue={this.props.setQuestionValue}
                uploadFiles={this.props.uploadFiles}
                uploadingFile={this.props.uploadingFile}
                selectedPlotId={this.props.selectedPlotId}
                mapMarkerComponent={this.props.mapMarkerComponent}
            />);
        }) : undefined;

        return (
            this.props.loading ?
                <div className="d-flex align-items-center bd-highlight justify-content-center pl-0 ml-0"
                    style={{ opacity: 0.75, width: "100%", height: "100%", minHeight: "50vh", zIndex: 80 }}>
                    <Loader type="ball-scale-multiple" active />
                    <div className="ml-4 small" style={{ color: Configuration.custom.defaultGraphColors[0] }}>please wait, loading survey</div>
                </div> :
                <Form
                    className="pb-2"
                    model="surveyState"
                    onSubmit={(surveyForm: SurveyState) => this.onSubmit(surveyForm)}
                    validateOn="submit"
                >
                    {//speciesControl
                    }
                    {eventTypeControl}
                    {dynamicFormItems}
                    {
                        survey ?
                            <button
                                disabled={this.props.uploadingFile}
                                className={`${this.props.theme} btn btn-block btn-primary btn-lg py-4 mb-5 mb-md-0 mt-3`}
                                type="submit">
                                SUBMIT
                        </button> : undefined
                    }
                    {this.props.submitFailed ? <span className="invalid-feedback d-block">Please check you have answered every required question</span> : undefined}
                </Form>
        );
    }
}

const mapStateToProps = (state: IAppState, ownProps: SurveyFormPropsAndActions): SurveyFormPropsMapped => {

    return {
        submitFailed: state.forms.surveyState && state.forms.surveyState.survey && state.forms.surveyState.survey.$form ? state.forms.surveyState.survey.$form.submitFailed : false,
        userPlots: state.data.userPlots
    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        getUserPlots: DataActionCreators.getUserPlotsRequest
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(withTheme<SurveyFormPropsAndActions>(withRouter(SurveyForm)));